export const WHATSAPP_LINKS = {
  focoseg: 'https://wa.me/5521982259050',
  exames: 'https://wa.me/5521969828445',
};
